import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class BinLineQueryCriteriaClass extends BaseCriteriaModel {
  guid_hdr?: Optional<string> = Optional.empty();
  item_guid?: Optional<string> = Optional.empty();

}

export class binLineCriteriaModelQuery {
  query = '';

  constructor(binLineCriteriaModel: BinLineQueryCriteriaClass) {

    if (!binLineCriteriaModel) {
      return;
    }

    this.query += binLineCriteriaModel.guid_hdr.filter(x => x !== '').map(x => '&guid_hdr=' + x).orElse('');
    this.query += binLineCriteriaModel.item_guid.filter(x => x !== '').map(x => '&item_guid=' + x).orElse('');

    this.query += '&status=' + binLineCriteriaModel.status;
    this.query += '&orderBy=' + binLineCriteriaModel.orderBy;
    this.query += '&order=' + binLineCriteriaModel.order;
    this.query += '&offset=' + binLineCriteriaModel.offset + '&limit=' + binLineCriteriaModel.limit;
  }
}

